import React from 'react'
import Modal from '../../atoms/Modal'
import LoadHtml from '../../atoms/LoadHtml'
import Loading from '../../atoms/Loading'

export default props =>
<Modal
      active={props.active}
      handleClose={ () => props.handleClose() }
      style={{
         width: '800px'
      }}>
   <LoadHtml
      file={require('./terms.xhtml')}
      loading={<Loading />}
      />
</Modal>



// WEBPACK FOOTER //
// ./src/SPRINTA/shared/ModalTerms/index.js